"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { BackIcon, AlertIcon } from "@/components/icons";
import { getBrandI18nKey } from "@/lib/branding";

const NotFound: React.FC = () => {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-64px)] bg-gradient-to-b from-[#FAFAFA] via-[#AFBBCF]/20 to-[#DBB29E]/40 text-center px-6">
      <div className="flex flex-col items-center space-y-4">
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-blue-100">
          <AlertIcon size={40} className="text-blue-600" />
        </div>

        <h1 className="text-5xl font-bold text-gray-800">404</h1>
        <p className="text-lg text-gray-600 max-w-md">
          {t("page-not-found-description")}
        </p>

        <Button
          asChild
          className="mt-4 bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-6 py-3 shadow"
        >
          <Link href="/">
            <BackIcon size={16} className="mr-2" />
            {t("btn-return-home")}
          </Link>
        </Button>
      </div>

      <footer className="absolute bottom-6 text-sm text-gray-400">
        {t(getBrandI18nKey("label-copyright"), {
          year: new Date().getFullYear(),
        })}
      </footer>
    </div>
  );
};
export default NotFound;
